import AGButton from '../../../components/Button';
import PDFPreviewFirstPage from '../../../components/PDFPreviewFirstPage';
import { BrochureProps } from './brochure.props';
import { Div } from './brochure.styled';


const ServiceBrochureItem = ({ data, isService, servicePdf }: BrochureProps) => {
    const apiDomain = process.env.REACT_APP_API_DOMAIN

    const downloadAttachment = async (path: string) => {
        try {
            const response = await fetch(`${apiDomain}/download/${path}`, {
                method: 'GET',
                headers: {
                    // Optionally, add any required headers here
                }
            });

            if (!response.ok) {
                throw new Error('Failed to download file');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = path;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    };

    return (
        <>
            {servicePdf && (
                <Div className="description w-full">
                    <PDFPreviewFirstPage pdfUrl={`${apiDomain}${servicePdf}`} />
                    <Div className='view-pdf'>
                        <AGButton
                            className='view-pdf-btn'
                            type={'Link'}
                            onClick={() => {
                                window.open(`${apiDomain}${servicePdf}`, '_blank');
                                // downloadAttachment(servicePdf!);
                            }}>
                            View PDF
                        </AGButton>
                    </Div>
                </Div>
            )}
        </>
    )
}

export default ServiceBrochureItem;